import { useEffect, useState } from "react";
import { BiPlus } from "react-icons/bi";
import { useNavigate, useParams } from "react-router-dom";
import Form from 'react-bootstrap/Form';
import { Select, Switch, Table } from "antd";
import { useDispatch } from "react-redux";
import { BsPencilSquare, BsSearch } from "react-icons/bs";
import { getLocalStorageData } from "../../utils/LocalStorageService";
import { ACTION_TYPE, REPORT_NAME, REPORT_PATH } from "../../components/constant/reportType";
import { COUNTRY_COLUMN, STATE_COLUMN } from "../../components/constant/AppConstant";
import { useDeleteCountryMutation, useGetAllCountryWithPaginationMutation, useGetAllCountryWithSearchMutation } from "../../redux-toolkit/services/countryService";
import { useDeleteStateMutation, useGetAllStatesMutation, useGetAllStatesWithSearchMutation } from "../../redux-toolkit/services/stateService";
import { useAppSelector } from "../../redux-toolkit/hooks";
import { getAllCountryTotalRecords, getAllCountryWithPaginationDetails, setAllCountriesWithPagination, setcountry, setCountryBySearch } from "../../redux-toolkit/slices/countrySlice";
import { getAllStatesTotalRecords, getAllStatesWithPaginationDetails, getStateSearch, setAllStatesWithPagination, setStatesBySearch } from "../../redux-toolkit/slices/statesSlice";
import { alertMessage } from "../../utils/AlertService";
import Loading from "../Loading";
import CommonData from "./CommonData";
import Button from 'react-bootstrap/Button';
import { useSaveAuditLogMutation } from "../../redux-toolkit/services/auditLogService";

const { Option } = Select;
type Props = {};
const Common = (props: Props) => {

  const params = useParams();
  const token: any = getLocalStorageData("localUser").token;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // States
  const [show, setShow] = useState(false);
  const [currentpage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [reportName, setReportName]: any = useState();
  const [actionType, setActionType] = useState(ACTION_TYPE.ADD_ACTION) as any;
  const [selectedRow, setSelectedRow]: any = useState([]);
  const [isSelect, setIsSelect] = useState(false);
  const [call, setCall] = useState("N");
  const [columData, setColumnData]: any = useState();


  const [dataSource, setDatasource]: any = useState([]);

  //get mutation
  const [getAllCountryWithPagination, getAllCountryWithPaginationResponse] = useGetAllCountryWithPaginationMutation();
  const [getAllStateWithPagination, getAllStateWithPaginationResponse] = useGetAllStatesMutation();

  //delete mutation
  const [deleteCountry, deleteCountryResponse] = useDeleteCountryMutation();
  const [deleteState, deleteStateResponse] = useDeleteStateMutation();

  //save
  const [logAudit] = useSaveAuditLogMutation();

  //selector
  const allCountry: any = useAppSelector(getAllCountryWithPaginationDetails);
  const allState: any = useAppSelector(getAllStatesWithPaginationDetails);
  const contrySearchData: any = useAppSelector(getAllCountryWithPaginationDetails);
  const stateSearchData: any = useAppSelector(getStateSearch);
  const allStatesTotalRecords: any = useAppSelector(getAllStatesTotalRecords);
  const allContryTotalRecords: any = useAppSelector(getAllCountryTotalRecords);

  //search
  const [getAllStatesWithSearch, getAllStatesWithSearchResponse] = useGetAllStatesWithSearchMutation();
  const [getAllCountriesWithSearch, getAllCountriesWithSearchResponse] = useGetAllCountryWithSearchMutation();

  useEffect(() => {
    switch (params.reportType) {
      case REPORT_PATH.COUNTRY:
        setReportName(REPORT_NAME.COUNTRY)
        break;
      case REPORT_PATH.STATE:
        setReportName(REPORT_NAME.STATE)
        break;
      default:
    }
  }, [params.reportType]);

  useEffect(() => {
    const temp: any = [];
    const tempAction: any = {
      title: "Action",
      dataIndex: "action",
      key: "name",
      fixed: "right",
      width: 120,
      render: (index: any, record: any) => {
        return (
          // for delete switch button
          <div className="d-flex justify-content-between">
            <div className="px-2 pe-auto">
              <Switch
                className={`${record.status === true ||
                  record.enabled === true ||
                  record.isActive === true ? "bg-accent" : "bg-secondry"}`}
                checked={
                  record.status === true ||
                    record.enabled === true ||
                    record.isActive === true
                    ? true
                    : false
                }
                onClick={() => {
                  onDeleteData(record);
                }}
              />
            </div>
            {record.status === true ||
              record.enabled === true ||
              record.isActive === true ? (
              <div
                className="px-2 pe-auto"
                onClick={() => {
                  handleOpenForm(record);
                }}
              >
                <BsPencilSquare size={18} />
              </div>
            ) : null}
          </div>
        );
      },
    };

    if (reportName === REPORT_NAME.STATE && STATE_COLUMN) {
      STATE_COLUMN.map((item: any) => {
        temp.push(item);
      });
      temp.push(tempAction);
      setColumnData(temp);
    } else if (reportName === REPORT_NAME.COUNTRY && COUNTRY_COLUMN) {
      COUNTRY_COLUMN.map((item: any) => {
        temp.push(item);
      });
      temp.push(tempAction);
      setColumnData(temp);
    }
  }, [reportName, params.reportType]);

  useEffect(() => {
    if (reportName === REPORT_NAME.STATE) {
      setIsSelect(true);

      getAllStateWithPagination({ token: token, page: currentpage - 1, offset: offset, orderBy: "asc" });
    } else if (reportName === REPORT_NAME.COUNTRY) {
      setIsSelect(true);
      getAllCountryWithPagination({ token: token, page: currentpage - 1, offset: offset, orderBy: "asc" });
    }
  }, [reportName]);

  useEffect(() => {
    if (call === "Y") {
      if (reportName === REPORT_NAME.STATE) {
        setIsSelect(true);
        getAllStateWithPagination({ token: token, page: currentpage - 1, offset: offset, orderBy: "asc" });
        setCall("N");
      } else if (reportName === REPORT_NAME.COUNTRY) {
        setIsSelect(true);
        getAllCountryWithPagination({ token: token, page: currentpage - 1, offset: offset, orderBy: "asc" });
        setCall("N");
      }
    }
  }, [call]);

  useEffect(() => {
    if (allCountry) {
      setDatasource(allCountry);
    }
  }, [allCountry]);

  useEffect(() => {
    if (allState) {
      setDatasource(allState);
    }
  }, [allState]);

  useEffect(() => {
    if (contrySearchData) {
      setDatasource(contrySearchData);
    }
  }, [allCountry]);

  useEffect(() => {
    if (stateSearchData) {
      setDatasource(stateSearchData);
    }
  }, [stateSearchData]);



  useEffect(() => {
    if (getAllCountryWithPaginationResponse.isSuccess) {
      dispatch(setAllCountriesWithPagination(getAllCountryWithPaginationResponse));
    } else if (getAllCountryWithPaginationResponse.isError) {
      let response: any = getAllCountryWithPaginationResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllCountryWithPaginationResponse.isSuccess, getAllCountryWithPaginationResponse.isError]);

  useEffect(() => {
    if (getAllStateWithPaginationResponse.isSuccess) {
      dispatch(setAllStatesWithPagination(getAllStateWithPaginationResponse));
    } else if (getAllStateWithPaginationResponse.isError) {
      let response: any = getAllStateWithPaginationResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllStateWithPaginationResponse.isSuccess, getAllStateWithPaginationResponse.isError]);

  const onDeleteData = (record: any) => {
    if (reportName === REPORT_NAME.COUNTRY) {
      deleteCountry({
        token: token,
        id: record.id,
      });

      const payload = {
        tableName: REPORT_NAME.COUNTRY,
        recordId: record.id,
        operationType: "DELETE",
        oldValue: record,
        newValue: { ...record, isActive: !record.isActive },
      };

      logAudit({
        token: token,
        payload: payload,
      });

    } else if (reportName === REPORT_NAME.STATE) {
      deleteState({
        token: token,
        id: record.id,
      });

      const payload = {
        tableName: REPORT_NAME.STATE,
        recordId: record.id,
        operationType: "DELETE",
        oldValue: record,
        newValue: { ...record, isActive: !record.isActive },
      };

      logAudit({
        token: token,
        payload: payload,
      });
    }
  };


  useEffect(() => {
    if (deleteCountryResponse.isSuccess) {
      alertMessage("Country status updated successfully", "success");
      setCall("Y");
    } else if (deleteCountryResponse.isError) {
      let response: any = deleteCountryResponse.error;
      alertMessage(response, "error");
    }
  }, [deleteCountryResponse.isSuccess, deleteCountryResponse.isError]);

  useEffect(() => {
    if (deleteStateResponse.isSuccess) {
      alertMessage("State status updated successfully", "success");
      setCall("Y");
    } else if (deleteStateResponse.isError) {
      let response: any = deleteStateResponse.error;
      alertMessage(response, "error");
    }
  }, [deleteStateResponse.isSuccess, deleteStateResponse.isError]);

  const handleOpenForm = (record: any) => {
    setShow(true);
    setActionType(ACTION_TYPE.UPDATE_ACTION);
    setSelectedRow(record);
  };

  const paginationChange = (page: number, offset: number) => {
    if (reportName === REPORT_NAME.STATE) {
      getAllStateWithPagination({
        token: token,
        page: page - 1,
        offset: offset,
        orderBy: "asc",
      });
    } else if (reportName === REPORT_NAME.COUNTRY) {
      getAllCountryWithPagination({
        token: token,
        page: page - 1,
        offset: offset,
        orderBy: "asc",
      });
    }
    setCurrentPage(page);
    setOffset(offset);
  };

  const handleShow = () => setShow(true);

  const handleSearch = (event: any) => {
    if (reportName === REPORT_NAME.STATE) {
      getAllStatesWithSearch({
        token: token,
        payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
      });
    } else if (reportName === REPORT_NAME.COUNTRY) {
      getAllCountriesWithSearch({
        token: token,
        payload: { offset: 100, pageNumber: 0, searchBy: event.target.value },
      });
    }
  };

  useEffect(() => {
    if (getAllStateWithPaginationResponse.isSuccess) {
      dispatch(setAllStatesWithPagination(getAllStateWithPaginationResponse));
    } else if (getAllStateWithPaginationResponse.isError) {
      let response: any = getAllStateWithPaginationResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllStateWithPaginationResponse.isSuccess, getAllStateWithPaginationResponse.isError]);

  useEffect(() => {
    if (getAllCountryWithPaginationResponse.isSuccess) {
      dispatch(setcountry(getAllCountryWithPaginationResponse.data));
    } else if (getAllCountryWithPaginationResponse.isError) {
      let response: any = getAllCountryWithPaginationResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllCountryWithPaginationResponse.isSuccess, getAllCountryWithPaginationResponse.isError]);



  useEffect(() => {
    if (getAllStatesWithSearchResponse.isSuccess) {
      dispatch(setStatesBySearch(getAllStatesWithSearchResponse));
    } else if (getAllStatesWithSearchResponse.isError) {
      let response: any = getAllStatesWithSearchResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllStatesWithSearchResponse.isSuccess, getAllStatesWithSearchResponse.isError]);

  useEffect(() => {
    if (getAllCountriesWithSearchResponse.isSuccess) {
      dispatch(setCountryBySearch(getAllCountriesWithSearchResponse));
    } else if (getAllCountriesWithSearchResponse.isError) {
      let response: any = getAllCountriesWithSearchResponse.error;
      alertMessage(response, "error");
    }
  }, [getAllCountriesWithSearchResponse.isSuccess, getAllCountriesWithSearchResponse.isError]);

  return (
    <div className="mt-2 overflow-y-auto">
      <div className="d-flex align-items-center justify-content-between flex-sm-row flex-column mb-2">
        <div className="d-flex align-items-center w-100 px-2">
          <h5
            className="m-0 px-0 d-flex align-items-center text-accent"
            style={{ fontWeight: "700" }}
          >
            {reportName}
          </h5>
        </div>
        <div className="d-flex align-items-center justify-content-start justify-content-sm-end cursor-pointer w-100">
          <div className="input-group px-2 mt-1">
            <Form.Control
              type="search"
              placeholder="Search"
              className="border-0"
              aria-label="Search"
              onChange={handleSearch}
            />
            <div className="input-group-append p-1 rounded-end">
              <span className="input-group-text border-0">
                <BsSearch className="" />
              </span>
            </div>
          </div>
          <div onClick={handleShow} className="d-flex px-2 align-items-center mt-1">
            <Button
              variant="dark"
              className="d-flex align-items-center me-0 text-nowrap bg-accent"
              onClick={() => setActionType(ACTION_TYPE.ADD_ACTION)}
            >
              <BiPlus />
              Add
            </Button>
          </div>
          {show && (
            <CommonData
              show={show}
              setShow={setShow}
              actionType={actionType}
              getAllReportAsync={() => null}
              updateAllReportAsync={({ }) => null}
              reportName={reportName}
              isSelect={isSelect}
              data={selectedRow}
              call={call}
              setCall={setCall}
            />
          )}
        </div>
      </div>

      <div className="d-flex ">
        {
            getAllStateWithPaginationResponse.isLoading ||
            getAllCountriesWithSearchResponse.isLoading ||
            getAllStatesWithSearchResponse.isLoading ||
            deleteCountryResponse.isLoading ||
            deleteStateResponse.isLoading ? (
            <Loading />
          ) : (
            ""
          )}

      </div>
      <div className="my-2 w-100 overflow-x-auto rounded-3">
        <Table
          bordered={true}
          rowKey={"id"}
          pagination={{
            total: (() => {
              switch (reportName) {
                case REPORT_NAME.STATE:
                  return allStatesTotalRecords;
                case REPORT_NAME.COUNTRY:
                  return allContryTotalRecords;

                default:
                  return [];
              }
            })(),
            responsive: true,
            current: currentpage,
            pageSizeOptions: [10, 20, 30],
            onChange: (page, pageSize) => {
              paginationChange(page, pageSize);
            },
            pageSize: offset,
          }}
          columns={columData}
          dataSource={dataSource}
        />
      </div>
    </div>
  );
};

export default Common;
